"use client";

import { HOME_PAGE } from "@/constants";
import { usePassportProvider } from "@/context";
import { useRouter } from "next/router";
import { type PropsWithChildren, useEffect } from "react";
import { Layout } from "./Layout";
type Props = PropsWithChildren & {
  screen: string;
  userJourney: string;
};

export function ProtectedLayout({ children, screen, userJourney }: Props) {
  const { isLoggedIn } = usePassportProvider();
  const router = useRouter();

  useEffect(() => {
    if (isLoggedIn === false) {
      router.replace({
        pathname: HOME_PAGE,
      });
    }
  }, [router, isLoggedIn]);

  return isLoggedIn === true ? (
    <Layout screen={screen} userJourney={userJourney}>
      {children}
    </Layout>
  ) : (
    <></>
  );
}
